import * as React from 'react';

import classNames from 'classnames';

import * as styles from './GallerySectionGridLayout.css';

export interface IGallerySectionGridLayoutProps {
  children: React.ReactNode[];
}

export const GallerySectionGridLayout: React.FC<IGallerySectionGridLayoutProps> = props => {
  const { children } = props;

  return <div className={classNames(styles['grid'], styles[`grid-size-${children.length}`])}>{children}</div>;
};
